

















































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { EfetivacaoAnaliseDocParm, EfetivacaoAnaliseDocsParm, UsuarioAnaliseEfetivacaoResult } from '@/interfaces/user';
import { downloadUserDocAnalysis, findUserDocsAnalysis, saveUserDocAnalysis } from '@/services/users';
import UserActivationForm from '@/views/users/screens/activation-form.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ActionsHistoryButton from '../UI/actions-history-button.vue';

@Component({
  components: {
    PermissionAuth,
    UiSelectDoctor,
    UiAutocompleClientsSubsidiaries,
    UserActivationForm,
    ActionsHistoryButton,
  },
})
export default class UserDocsForm extends BaseComponent {
  @Prop()
  private token: string;
  private res: UsuarioAnaliseEfetivacaoResult = null;
  private observacoes: string = null;
  private aprovado: boolean = null;
  private msgUltimaAnalise: string = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      aprovacao: [(v) => v != null || 'Selecione Aprovado ou Rejeitado'],
      observacao: [(v) => !!v || 'Informe a mensagem para enviar por e-mail ao usuário '],
      motivoRejeicao: [(v) => !!v || 'Informe a motivo da rejeição do arquivo'],
    },
  };

  private tableHeaders: any = [
    { text: 'Download', sortable: false },
    { text: 'Tipo', value: 'tipo.nome', sortable: false },
    { text: 'Nome do arquivo', value: 'nomeOriginal', sortable: false },
    { text: 'Data de inclusão', value: 'dataUpload', sortable: false },
    { text: 'Analista', value: 'analista', sortable: false },
    { text: 'Data de análise', value: 'dataAnalise', sortable: false },
    { text: 'Situação', value: 'situacao.nome', sortable: false, align: 'center' },
    { text: 'Resultado da análise', value: '', sortable: false, width: '400px' },
  ];

  private tableHeadersReadOnly: any = [
    { text: 'Download', sortable: false },
    { text: 'Tipo', value: 'tipo.nome', sortable: false },
    { text: 'Nome do arquivo', value: 'nomeOriginal', sortable: false },
    { text: 'Data de inclusão', value: 'dataUpload', sortable: false },
    { text: 'Analista', value: 'analista', sortable: false },
    { text: 'Data de análise', value: 'dataAnalise', sortable: false },
    { text: 'Situação', value: 'situacao.nome', sortable: false },
    { text: 'Motivo', value: '', align: 'center', sortable: false },
  ];

  @Watch('token')
  private onTokenChange() {
    if (!this.token) {
      this.res = null;
      return;
    }
    this.res = null;
    this.loader.start('Carregando ...');
    findUserDocsAnalysis(this.token).subscribe(
      (res) => {
        this.res = res;
        this.msgUltimaAnalise = res.observacao;
        res.observacao = null;
        this.loader.stop();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
    );
  }

  public closeForm(): void {
    const closeAction = () => {
      this.res = null;
      this.$emit('close');
    };

    if (this.res && this.res.alteravel) {
      this.dialog.show(
        'error',
        'Sair sem salvar',
        'Deseja sair sem salvar as alterações?',
        'Cancelar',
        '',
        'Sair',
        closeAction,
      );
    } else {
      closeAction();
    }
  }

  private download(item) {
    this.loader.start('Processando...');
    downloadUserDocAnalysis(this.token, item.id).subscribe(
      (res) => {
        this.loader.stop();
        this.forceFileAxiosResponseDownload(res, item.nomeOriginal);
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
    );
  }

  private onAprovadoDocChange() {
    this.aprovado = this.res.docs.filter((d) => (d as any).aprovado === false && (d as any).analisar).length == 0;
  }

  private salvar(solicitarAjustes: boolean) {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    let parm = new EfetivacaoAnaliseDocsParm();
    parm.uuid = this.token;
    parm.mensagemAoUsuario = this.res.observacao;
    parm.documentos = new Array();
    parm.solicitarAjustes = solicitarAjustes;
    this.res.docs.filter(d=> (d as any).analisar).forEach((d) => {
      let doc = new EfetivacaoAnaliseDocParm();
      doc.id = d.id;
      doc.aprovado = (d as any).aprovado;
      doc.motivo = (d as any).motivo;
      parm.documentos.push(doc);
    });
    this.loader.start('Processando...');
    saveUserDocAnalysis(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(res, 'success');
        this.$emit('aftersave');
        this.res = null;
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
    );
  }
}
